
angular.module('listviewModule').component('listviewListingImage', {
	templateUrl: 'listviewListingImage/listviewListingImage.html',
	bindings: {
		item: '=',
		image: '=',
		imageIndex: '@',
		isFloorplan: '@'
	},
	controller: ['$element', '$window', '$timeout', 'PubSub', 'ImageService', function($element, $window, $timeout, PubSub, ImageService) {
		var ctrl = this;

		this.$onInit = function() {
			this.widthThumbnail = 80;
			this.heightThumbnail = 60;
			this.widthPopup = 275;
			this.heightPopup = 200;
		};

		this.showViewer = function() {
			var mask_id = this.item.mask_id || this.item.history_id || this.item.id; //this.item.mask_id ? this.item.mask_id : this.item.history_id;
			var elClass = '.image_viewer._' + mask_id;
			var imageViewer = this.imageViewer = angular.element(document.querySelector(elClass));
			var imageViewerStyles = window.getComputedStyle(imageViewer[0], null);
			var parent = imageViewer.parent();
			var parentPhotos = angular.element(parent[0].querySelector('.photos'));
			var parentPhotosRect = parentPhotos[0].getBoundingClientRect();

			if (angular.element($element).hasClass('first')) {
				var cls = 'for_first_item';
				angular.element(imageViewer).addClass(cls);
			} else {
				var parentElement = $element.parent();
				var elemRect = parentElement[0].getBoundingClientRect();
				var posX = (elemRect.left - parentPhotosRect.left) - (imageViewerStyles.width.toInt() / 2) + (elemRect.width / 2);

				if (angular.element(imageViewer).hasClass('for_first_item')) {
					angular.element(imageViewer).removeClass('for_first_item');
				}

				imageViewer.css({
					left: posX + 'px'
				});
			}

			this.item.showViewer = true;

			if (Array.isArray(this.image)) {
				this.item.activeImage = ImageService.getSmartImage(this.widthPopup, this.heightPopup, this.image[1], 'fit-in', 'webp'); // medium size image 
			} else if (typeof this.image === 'object') {
				this.item.activeImage = ImageService.getSmartImage(this.widthPopup, this.heightPopup, this.image.medium, 'fit-in', 'webp'); // medium size image
			} else {
				this.item.activeImage = ImageService.getSmartImage(this.widthPopup, this.heightPopup, this.image, 'fit-in', 'webp');
			} 

			this.item.activeImageIndex = this.imageIndex;
		};

		this.hideViewer = function(item) {
			this.item.showViewer = false;
		};

		this.imageThumbnail = function() {
			if (Array.isArray(this.image)) {
				return this.image.length ? ImageService.getSmartImage(this.widthThumbnail, this.heightThumbnail, this.image[this.image.length - 1], 'fit-in', 'webp') : null;
			} else if (typeof this.image === 'object') {
				return ImageService.getSmartImage(this.widthThumbnail, this.heightThumbnail, this.image.thumb, 'fit-in', 'webp');
			} else {
				return ImageService.getSmartImage(this.widthThumbnail, this.heightThumbnail, this.image, 'fit-in', 'webp');
			}

			return null;
		};

		this.openListingGalleryPopup = function(e) {
			e && e.preventDefault();
			let photogallerylink = this.imageViewer[0].querySelector('[cr-photogallery-link-v2]');
			if (photogallerylink) {
				let maskId = ctrl.item.mask_id || ctrl.item.history_id;
				// photogallerylink.fireEvent('click');
				let data = {
					'target': e.currentTarget,
					'isFloorplan': ctrl.isFloorplan,
					'index': ctrl.item.activeImageIndex,
					'maskId': maskId,
					'photogallerylink': photogallerylink
				};
				PubSub.publish('setPopupTriggerAndSelectThumb_' + maskId, data);
			}
		};
	}]
});
